import { useNavigate } from 'react-router-dom';
import { useNavigationTracker } from '../context/NavigationContext';

export const useGoBack = () => {
    const navigate = useNavigate();
    const { getPrevious } = useNavigationTracker();

    return () => {
        const prev = getPrevious();
        if (prev?.state?.pathname) {
            navigate(prev.state.pathname, { state: prev.state || {} });
        } else if (window.history.length > 2) {
            navigate(-1, { state: prev?.state || {} });
        }
        else {
            navigate("/", { state: prev?.state || {} });
        }
    };
};